import { render, staticRenderFns } from "./DemoProcess.vue?vue&type=template&id=f859cb6c&scoped=true"
import script from "./DemoProcess.vue?vue&type=script&lang=js"
export * from "./DemoProcess.vue?vue&type=script&lang=js"
import style0 from "./DemoProcess.vue?vue&type=style&index=0&id=f859cb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f859cb6c",
  null
  
)

export default component.exports